"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var ServiceAccordion = (function (_super) {
    __extends(ServiceAccordion, _super);
    function ServiceAccordion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceAccordion.prototype.init = function () {
        setTimeout(function () {
            var article = jquery_1.default('article[data-anchor="' + location.hash + '"]');
            if (article.length) {
                article.addClass('open').find('.content').show();
                document.body.scrollTop = article.offset().top - jquery_1.default('.utility-bar').height();
            }
        }, 200);
        this.el.on('click', '.accordion article > h1', function () {
            var article = jquery_1.default(this).closest('article');
            var accordion = jquery_1.default(this).closest('.accordion');
            if (article.hasClass('open')) {
                article.find('.content').stop().slideUp(200);
                article.removeClass('open');
            }
            else {
                accordion.find('.open').removeClass('open').find('.content').stop().slideUp(200);
                article.addClass('open');
                article.find('.content').stop().slideDown(200, function () {
                    jquery_1.default(this).closest('[data-anchor]').each(function (index, node) {
                        var subject = jquery_1.default(node).find('[href=' + jquery_1.default(node).attr('data-anchor') + ']').text();
                        ServiceAccordion.getBus().notify('serviceAccordion.open', subject);
                    });
                });
            }
        });
    };
    return ServiceAccordion;
}(Widget_1.Widget));
exports.ServiceAccordion = ServiceAccordion;
